// @flow

import { combineReducers } from 'redux';
import {
  FLUSH_CACHED_ROUTES,
  GET_ROUTE,
  GET_ROUTE_SUCCESS,
  GET_ROUTE_FAILED,
  ACTIVATE_ITEM,
} from '../constants';
import { routeReducer } from './route';
import type {
  State,
  Items,
  ActiveItem,
  Actions,
  ActivateItem,
} from '../types';

const initialState: State = {
  activeItem: null,
  items: {},
};

const items = (state: Items = initialState.items, action: Actions): Items => {
  switch (action.type) {
    case GET_ROUTE:
    case GET_ROUTE_FAILED:
    case GET_ROUTE_SUCCESS:
      return {
        ...state,
        [action.slug]: {
          ...routeReducer(state[action.slug], action),
        },
      };
    case FLUSH_CACHED_ROUTES:
      return initialState.items;
    default:
      return state;
  }
};

const activeItem = (
  state: ActiveItem = initialState.activeItem,
  action: ActivateItem,
): ActiveItem => {
  switch (action.type) {
    case ACTIVATE_ITEM:
      return action.slug;
    default:
      return state;
  }
};

export default combineReducers<Object, Object>({
  activeItem,
  items,
});
